import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EvrideoCommonModule } from "../common/evrideo-common.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ToastrModule } from "ngx-toastr";
import { RouterModule } from "@angular/router";
import { InlineSVGModule } from "ng-inline-svg-2";
import { FormsModule } from "@angular/forms";
import { OutpostComponent } from "./outpost.component";
import { OutpostRoutes } from "./outpost.routes";
import { OutpostRemoteComponent } from "./remote/outpost-remote.component";
import {OutpostSidebarComponent} from "./sidebar/outpost-sidebar.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    EvrideoCommonModule,
    BrowserAnimationsModule,
    InlineSVGModule.forRoot(),
    ToastrModule.forRoot({
      positionClass: "toast-top-center",
      tapToDismiss: false,
      timeOut: 5000,
    }),
    RouterModule.forRoot(OutpostRoutes),
  ],
  declarations: [
    OutpostComponent,
    OutpostSidebarComponent,
    OutpostRemoteComponent,
  ],
  providers: [],
  exports: [RouterModule, InlineSVGModule, ToastrModule],
})
export class OutpostModule {}
